import { Mesh } from 'three';
import React from 'react';

export default {
    name: '[pipe]ventil',
    prototype: 'holes',

    info: {
        tag: ['ventil'],
        title: 'Ventil',
        description: 'Ventil',
        image: require('./ventil.png')
    },

    properties: {
        width: {
            label: 'Width',
            type: 'length-measure',
            defaultValue: {
                length: 20
            }
        },
        flip_orizzontal: {
            label: 'flip orizzontale',
            type: 'checkbox',
            defaultValue: false,
            values: {
                'none': false,
                'yes': true
            }
        },
    },

    render2D: function (element, layer, scene) {

        let width = element.properties.get('width').get('length');
        let flip = element.properties.get('flip_orizzontal');

        if (flip === false) {
            return (
                <g transform={`scale(${width * 0.05} ${width * 0.05}) translate(5, -5) rotate(180)`}>
                    <path d="M0 0 L4 0 L9 -3 L11 -3 L16 0 L20 0 L20 -9 L16 -9 L11 -6 L11 -11 L14 -11 L14 -14 L5 -14 L5 -11 L8 -11 L8 -6 L4 -9 L0 -9 z" stroke="#000000" fill="#000000" />
                </g>
            )
        } else {
            return (
                <g transform={`scale(${width * 0.05} ${width * 0.05}) translate(-15, 4)`}>
                    <path d="M0 0 L4 0 L9 -3 L11 -3 L16 0 L20 0 L20 -9 L16 -9 L11 -6 L11 -11 L14 -11 L14 -14 L5 -14 L5 -11 L8 -11 L8 -6 L4 -9 L0 -9 z" stroke="#000000" fill="#000000" />
                </g>
            )
        }
    },

    render3D: function (element, layer, scene) {
        let mesh = new Mesh();
        return Promise.resolve(mesh);
    }
};
